import { useSuspenseQuery } from '@tanstack/react-query'
import { Conversation } from '@botpress/client'
import { DateTime } from 'luxon'
import { Icon, Link } from '~/elements'
import { getIntegrationByNameQueryOptions } from '~/queries'
import { cn } from '~/utils'

type Props = {
  conversation: Conversation
  botId: string
  workspaceId: string
  className?: string
}

const ConversationSummary = ({ conversation, botId, workspaceId, className }: Props) => {
  const integration = useSuspenseQuery(getIntegrationByNameQueryOptions({ name: conversation.integration })).data
  return (
    <div key={conversation.id} className={cn('flex items-start gap-2', className)}>
      <Icon
        size="2"
        className="mt-1.5"
        variant={'surface'}
        color={'gray'}
        icon={(props) => <img src={integration.iconUrl} {...props} />}
      />
      <div className="flex flex-col truncate">
        <Link
          to="/workspaces/$workspaceId/bots/$botId/conversations/$conversationId"
          params={{ botId, conversationId: conversation.id, workspaceId }}
          className="truncate"
        >
          {conversation.id}
        </Link>
        <p className="truncate text-xs text-muted-foreground">
          {DateTime.fromISO(conversation.updatedAt).toRelative()}
        </p>
      </div>
    </div>
  )
}

export { ConversationSummary }
